// units/pages/UnitManagementPage.tsx
import { FC } from "react";
import { PageEnum } from "../../models";
import {LoadingBox, ErrorValidationBox, ToastBox, RegisterUnit, ConfirmModelDialogBox, UnitList} from "..";
import { Accordion, Card } from "react-bootstrap";
import {getLabelName} from "../../utils";
import {useUnitManager} from "../../hooks";

/**
 * The main page component for Unit Management
 * Combines unit registration and listing in a single page
 */
export const UnitManagement: FC = () => {
    //#region variables
    const formId = PageEnum.Units;
    //#endregion
    //#region hooks
    // Get state and actions directly from the simplified store
    const {
        loading,
        validationErrors,
        toastModel,
        showDeleteUnitModel,
        isRefresh,
        setToastModel,
        setShowDeleteUnitModel,
        deleteUnitActions
    } = useUnitManager();
    //#endregion
    //#region html
    return (
        <>
            {/* Show loading state */}
            {loading && <LoadingBox />}

            {/* Display validation errors */}
            {<ErrorValidationBox errors={validationErrors} />}

            {/* Toast notifications */}
            {toastModel.show && (
                <ToastBox
                    isShown={toastModel.show}
                    header={toastModel.header}
                    body={toastModel.body}
                    variant={toastModel.variant}
                    delayDuration={toastModel.delayDuration}
                    onCloseEvent={() => {
                        setToastModel({ ...toastModel, show: false });
                    }}
                />
            )}

            {/* Unit Registration Section */}
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{getLabelName("Units")}</Accordion.Header>
                    <Accordion.Body>
                        <Card>
                            <Card.Body>
                                <RegisterUnit formId={formId} />
                            </Card.Body>
                        </Card>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            {/* Unit List Section */}
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{getLabelName("Previous Data")}</Accordion.Header>
                    <Accordion.Body>
                        <Card className="card-custom">
                            <Card.Body>
                                {/* Delete Confirmation Dialog */}
                                <ConfirmModelDialogBox
                                    isModelVisible={showDeleteUnitModel}
                                    onCloseEvent={() => setShowDeleteUnitModel(false)}
                                    actions={deleteUnitActions}
                                />

                                {/* Unit List Component */}
                                <UnitList
                                    isRefresh={isRefresh}
                                    formId={formId}
                                />
                            </Card.Body>
                        </Card>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
    //#endregion
};


// Backward compatibility
//export const UnitMainComponents = UnitManagement;

//export default UnitManagementPage;